
import { utils } from '../../utils/index.js';
utils.fixViewport('Gallery');

import React from 'react'
import GroupView from '../group/groupView.js'
import GalleryEmpty from './galleryEmpty.js'
import GalleryLayout from './galleryLayout.js'
import GalleryDebugMessage from './galleryDebugMessage.js'
import _ from 'lodash';

class SlideshowView extends React.Component {

  constructor(props) {
    super(props);

    this.scrollToItem = this.scrollToItem.bind(this);
    this.handleKeypress = this.handleKeypress.bind(this);
    this._setCurrentItemByScroll = _.throttle(this.setCurrentItemByScroll, 600, {'leading': false, 'trailing': true}).bind(this);

    this.state = {
      flatItems: [],
      currentIdx: 0,
    };

  }

  isFirstItem() {
    if (!_.isUndefined(this.state.currentIdx)) {
      return this.state.currentIdx == 0;
    }

    return 0 == this.props.scroll.top;

  }

  isLastItem() {

    return this.state.currentIdx >= this.props.totalItemsCount - 1;

  }

  nextItem(dir) {

    this.isAutoScrolling = true;

    var currentIdx = this.state.currentIdx;

    if (this.props.styleParams.showArrows) {
      this.props.actions.scrollToItem(currentIdx + dir, false, true);
    } else {
      this.props.actions.scrollToItem(dir, true, true);
    }

    utils.setStateAndLog(this, 'Next Item', {
      currentIdx: currentIdx + dir
    });

  }

  scrollToItem(itemIdx) {

    this.isAutoScrolling = true;

    itemIdx += this.firstItemIdx;

    utils.setStateAndLog(this, 'Scroll to Item', {
      currentIdx: itemIdx
    });

    this.props.actions.scrollToItem(itemIdx, false, true);

  }

  handleKeypress(e) {
    switch (e.charCode || e.keyCode) {
      case 38: //up
      case 37: //left
      case 33: //page up
        e.preventDefault();
        this.nextItem(-1);
        return false;
      case 39: //right
      case 40: //down
      case 32: //space
      case 34: //page down
        e.preventDefault();
        this.nextItem(1);
        return false;
    }

    return true; //continue handling the original keyboard event

  }

  createThumbnails(thumbnailPosition) {
    var currentIdx = this.state.currentIdx; // zero based (3)
    console.log('creating thumbnails for idx', currentIdx);

    var width = this.props.thumbnailSize;
    var height = this.props.thumbnailSize;

    var oneRow;
    var numOfThumbnails; //1 based (5)

    switch (thumbnailPosition) {
      case 'top':
      case 'bottom':
        width = window.innerWidth / utils.getViewportScaleRatio();
        oneRow = true;
        numOfThumbnails = Math.ceil(width / this.props.thumbnailSize);
        break;
      case 'left':
      case 'right':
        height = window.innerHeight * utils.getViewportScaleRatio();
        oneRow = false;
        numOfThumbnails = Math.ceil(height / this.props.thumbnailSize);
        break;
    }

    this.firstItemIdx = currentIdx - Math.floor(numOfThumbnails / 2); // (1)
    this.lastItemIdx = this.firstItemIdx + numOfThumbnails - 1; // (5)

    if (this.firstItemIdx < 0) {
      this.lastItemIdx -= this.firstItemIdx;
      this.firstItemIdx = 0;
    }

    if (this.lastItemIdx > this.props.items.length - 1) {
      this.firstItemIdx -= (this.lastItemIdx - (this.props.items.length - 1));
      if (this.firstItemIdx < 0) {
        this.firstItemIdx = 0;
      }
      this.lastItemIdx = this.props.items.length - 1;
    }

    numOfThumbnails = this.lastItemIdx - this.firstItemIdx + 1;
    if (numOfThumbnails % 2 == 0) { // keep an odd number of thumbnails
      numOfThumbnails += 1;
      this.lastItemIdx += 1;
    }
    var thumbnailsContainerSize = numOfThumbnails * this.props.thumbnailSize;
    var thumbnailsStyle = {width, height};

    if ((currentIdx > ((numOfThumbnails / 2) - 1)) && (currentIdx < (this.props.items.length - (numOfThumbnails / 2))) )  { //set selected to center only if neeeded
      switch (thumbnailPosition) {
        case 'top':
        case 'bottom':
          thumbnailsStyle.width = thumbnailsContainerSize + 'px';
          thumbnailsStyle.left = 0;
          break;
        case 'left':
        case 'right':
          thumbnailsStyle.height = thumbnailsContainerSize + 'px';
          thumbnailsStyle.marginTop = ((height - thumbnailsContainerSize) / 2) + 'px';
          break;
      }
    } else if (currentIdx < ((numOfThumbnails / 2) - 1)) { //one of the first thumbnails
      switch (thumbnailPosition) {
        case 'top':
        case 'bottom':
          thumbnailsStyle.width = thumbnailsContainerSize + 'px';
          thumbnailsStyle.left = 0;
          break;
        case 'left':
        case 'right':
          thumbnailsStyle.height = thumbnailsContainerSize + 'px';
          thumbnailsStyle.marginTop = 0;
          break;
      }
    } else if (this.lastItemIdx > numOfThumbnails && currentIdx >= this.lastItemIdx - 3 ) { //scroll to the left/top if the chosen thumbnail is one of the last three
      let entireThumbnailsSize = thumbnailsContainerSize - this.props.styleParams.thumbnailSpacings;
      switch (thumbnailPosition) {
        case 'top':
        case 'bottom':
          thumbnailsStyle.left = (width - entireThumbnailsSize) + 'px';
          thumbnailsStyle['overflow'] = 'visible';
          break;
        case 'left':
        case 'right':
          thumbnailsStyle.top = (height - entireThumbnailsSize) + 'px';
          thumbnailsStyle['overflow'] = 'visible';
          break;
      }
    }

    var thumbnailsLayout = new GalleryLayout({
      items: this.props.items.slice(this.firstItemIdx, this.lastItemIdx + 1),
      container: _.merge({}, this.props.container, {
        galleryWidth: width,
        galleryHeight: height
      }),
      watermark: this.props.watermark,
      styleParams: {
        gotStyleParams: false,
        isVertical: false,
        gallerySize: this.props.thumbnailSize,
        minItemSize: this.props.thumbnailSize,
        groupSize: 1,
        chooseBestGroup: false,
        groupTypes: '1',
        cubeImages: true,
        smartCrop: false,
        collageAmount: 0,
        collageDensity: 0,
        cubeRatio: 1,
        fixedColumns: 0,
        oneRow: oneRow
      },
      gotScrollEvent: true,
      showAllItems: true
    });

    var thumbnailsConfig = {
      scroll: _.merge({}, this.props.scroll, {}),
      thumbnailHighlightId: _.get(this, `props.items.${currentIdx}.itemId`),
      watermark: this.props.watermark,
      styleParams: _.merge({}, this.props.styleParams, {
        allowSocial: false,
        allowDownload: false,
        allowTitle: false,
        allowMultishare: false,
        loveButton: false,
        loveCounter: false,
        videoLoop: false,
        videoSpeed: 1,
        videoPlay: 'onClick',
        sharpParams: {
          quality: 90,
          usm: {}
        },
        imageMargin: this.props.styleParams.thumbnailSpacings,
        enableInfiniteScroll: 0,
        showArrows: false,
        itemClick: 'expand'
      }),
      actions: {
        scrollToItem: this.scrollToItem,
        toggleFullscreen: this.props.actions.toggleFullscreen,
        pauseAllVideos: this.props.actions.pauseAllVideos,
      },
      hidePlay: true
    };

    var thumbnailsMargin;
    var mrg = this.props.styleParams.thumbnailSpacings;
    switch (this.props.styleParams.galleryThumbnailsAlignment) {
      case 'bottom':
        thumbnailsMargin = `${mrg}px -${mrg}px -${mrg}px -${mrg}px`;
        break;
      case 'left':
        thumbnailsMargin = `-${mrg}px ${mrg}px -${mrg}px -${mrg}px`;
        break;
      case 'top':
        thumbnailsMargin = `-${mrg}px -${mrg}px ${mrg}px -${mrg}px`;
        break;
      case 'right':
        thumbnailsMargin = `-${mrg}px -${mrg}px -${mrg}px ${mrg}px`;
        break;
    }

    var thumbnails = (
      <div className={"pro-gallery inline-styles thumbnails-gallery " + (oneRow ? " one-row hide-scrollbars " : "") + (utils.isAccessibilityEnabled() ? ' accessible ' : '')}
           style={{
             width,
             height,
             margin: thumbnailsMargin
           }}
            data-hook="gallery-thumbnails">

        {thumbnailsLayout.columns.map((column, c) => {
          return (
            <div data-hook='gallery-column' className="gallery-column" key={'thumbnails-column' + c}
                 style={thumbnailsStyle}>
              {column.map((group) => React.createElement(GroupView, group.getViewProps(thumbnailsConfig)))}
            </div>
          );

        })}
      </div>
    );

    return thumbnails;

  }

  setFlattenItems(galleryLayout) {
    var flatItems = _.flattenDeep(galleryLayout.columns.map((column, c) => {
      return column.map((group, g) => {
        return group.items
      });
    }));

    this.setState({
      flatItems
    })
  }

  setCurrentItemByScroll() {

    console.log('Setting current Idx by scroll', this.isAutoScrolling);

    if (this.isAutoScrolling) {
      //avoid this function if the scroll was originated by us (arrows or thumbnails)
      this.isAutoScrolling = false;
      return;
    }

    var scrollLeft = this.container.scrollLeft();

    var items = this.state.flatItems;

    var currentIdx;

    for (var item, i = 0; item = items[i]; i++) {
      if (item.offset.left >= scrollLeft + ((this.props.container.galleryWidth - item.width) / 2)) {
        currentIdx = i - 1;
        break;
      }
    }

    if (!_.isUndefined(currentIdx)) {
      utils.setStateAndLog(this, 'Set Current Item', {
        currentIdx: currentIdx
      });
    }
  }

  componentWillReceiveProps(props) {
    if (props.items) {
      this.setFlattenItems(props.galleryLayout);
    }
  }

  componentWillMount() {

    if (!(this.props.renderedItemsCount > 0) && utils.isEditor()) {
      return (<GalleryEmpty
          actions={{
            setWixHeight: this.props.actions.setWixHeight
          }}
        />
      );
    }
  }

  componentDidMount() {
    if (this.props.galleryLayout) {
      this.setFlattenItems(this.props.galleryLayout);
    }

    window.addEventListener('keydown', this.handleKeypress);

    this.container = $('.gallery-horizontal-scroll');
    if (this.container[0]) {
      this.container[0].addEventListener('scroll', this._setCurrentItemByScroll);
    }
    this.setCurrentItemByScroll();

    // if (utils.isSite() && this.props.styleParams.selectedLayoutV2 == 4 && this.props.renderedItemsCount > 2) {
    //   this.nextItem(1);
    // }
  }

  componentWillUnmount() {
    this.container[0].removeEventListener('scroll', this._setCurrentItemByScroll);
  }

  //-----------------------------------------| RENDER |--------------------------------------------//

  render() {
    if (utils.isDev()) {
      console.count("galleryView render");

      //this.gallery = this.prepareGallery(this.state.images);
      console.count('Rendering Gallery count');
      console.time('Rendering Gallery took ');
    }

    var loader = (this.totalItemsCount > this.props.renderedItemsCount) ? (
      <div className="more-items-loader"><i className="pro-circle-preloader"/></div>
    ) : false;

    var navArrows = [
      (this.isFirstItem() ? '' : <button
        className={"nav-arrows-container prev "}
        onClick={() => this.nextItem(-1)}
        aria-label="Previous Item"
        tabIndex={utils.getTabIndex('slideshowPrev')}
        key="nav-arrow-back"
        data-hook="nav-arrow-back"
      >
        <img src={`${window.staticsUrl}assets/images/arrows/arrow-left.svg`} />
      </button>),
      (this.isLastItem() ? '' : <button
        className={"nav-arrows-container next"}
        onClick={() => this.nextItem(1)}
        aria-label="Next Item"
        tabIndex={utils.getTabIndex('slideshowNext')}
        key="nav-arrow-next"
        data-hook="nav-arrow-next"
      >
        <img src={`${window.staticsUrl}assets/images/arrows/arrow-right.svg`} />
      </button>)
    ];

    var debugMsg = (
      <GalleryDebugMessage {...this.props.debug} />
    );

    var galleryConfig = {
      scroll: this.props.scroll,
      styleParams: this.props.styleParams,
      multishare: this.props.multishare,
      watermark: this.props.watermark,
      currentIdx: this.state.currentIdx,
      actions: {
        toggleFullscreen: this.props.actions.toggleFullscreen,
        pauseAllVideos: this.props.actions.pauseAllVideos,
        addItemToMultishare: this.props.actions.addItemToMultishare,
        removeItemFromMultishare: this.props.actions.removeItemFromMultishare
      }
    };

    var layout = (
      this.props.galleryLayout.columns.map((column, c) => {

        var marginLeft = 0;
        var firstGroup = _.find(column, (group) => group.rendered) || {};
        if (this.props.gotScrollEvent) {
          marginLeft = firstGroup.left || 0;
        }

        //remove navBars if no scroll is needed and is column layout
        const allRenderedGroups = _.filter(column, (group) => group.rendered) || [];
        const allGroupsWidth = allRenderedGroups.reduce((sum, group) => {
          return sum + group.width;
        }, 0);
        const isAllItemsFitsGalleryWidth = this.props.styleParams.oneRow && (this.props.container.galleryWidth >= allGroupsWidth);
        if (isAllItemsFitsGalleryWidth) {
          navArrows = false;
        }

        return (
          <div data-hook='gallery-column' className="gallery-horizontal-scroll gallery-column hide-scrollbars" key={'column' + c}
               style={{width: this.props.galleryLayout.colWidth}}>
            <div className="gallery-left-padding" style={{width: marginLeft}}></div>
            {column.map((group) => group.rendered ? React.createElement(GroupView, _.merge(group.getViewProps(galleryConfig), {store: this.props.store} )) : false)}
          </div>
        );

      })
    );

    var hasThumbnails = this.props.styleParams.hasThumbnails;
    var thumbnailsPosition = this.props.styleParams.galleryThumbnailsAlignment;

    var thumbnailsGallery = hasThumbnails ? this.createThumbnails(thumbnailsPosition) : false;

    var galleryStyle = {
      height: this.props.container.galleryHeight,
      width: this.props.container.galleryWidth
    };

    var thumbnails = [];
    switch (thumbnailsPosition) {
      case 'top':
      case 'left':
        thumbnails[0] = thumbnailsGallery;
        thumbnails[1] = false;
        break;
      case 'right':
      case 'bottom':
        thumbnails[0] = false;
        thumbnails[1] = thumbnailsGallery;
        break;
    }

    var gallery = (
      <div id="pro-gallery-container" className={"pro-gallery inline-styles one-row hide-scrollbars " + (this.props.styleParams.enableScroll ? " slider " : "") + (utils.isAccessibilityEnabled() ? ' accessible ' : '')}
           style={galleryStyle}
      >
        {debugMsg}
        {layout}
        {loader}
        {navArrows}
      </div>
    );

    if (utils.isDev()) {
      console.timeEnd('Rendering Gallery took ');
    }

    var classNames = '';
    if (this.props.styleParams.isSlideshow) {
      classNames = ' gallery-slideshow';
    } else if (this.props.styleParams.isSlider) {
      classNames = ' gallery-slider';
    } else if (this.props.styleParams.hasThumbnails) {
      classNames = ' gallery-thumbnails';
    } else if (this.props.styleParams.isColumns) {
      classNames = ' gallery-columns';
    }

    if (this.props.container.galleryWidth >= ($(window).width() - 10)) {
      classNames += ' streched';
    }

    return (<div className={classNames}>
      {thumbnails[0]}
      {gallery}
      {thumbnails[1]}
    </div>);

  }

}


export default SlideshowView;



// WEBPACK FOOTER //
// ./components/gallery/slideshowView.js